// extracted by mini-css-extract-plugin
export var containedImageSliderWrapper = "style-module--containedImageSliderWrapper--8b951";
export var fullWidthImageSlider = "style-module--fullWidthImageSlider--2512d";
export var fullWidthImageSliderWrapper = "style-module--fullWidthImageSliderWrapper--1ea10";